export default "__VITE_PUBLIC_ASSET__2c710c36__"